import { useTranslation } from "react-i18next";
import { SelectField, } from "melco-shared-logic";
import sortBy from "lodash-es/sortBy";
import { usePartners } from "../../hooks/settings/usePartners";

export const SelectPartnerField: React.FC = () => {
    const { t } = useTranslation();

    const { data: partners, isLoading } = usePartners();

    const filteredPartners = (partners ?? [])

    const unsortedOptions = filteredPartners.map(({ code, name }) => {
        return {
            label: name ?? code ?? "",
            value: code ?? "",
        };
    });

    const options = sortBy(unsortedOptions, ["label"], ["asc"]);

    return (
        <SelectField
            name="partner"
            label={t("eodsettings.actions.add.form.label.type")}
            options={options}
            optionFilterProp="label"
            loading={isLoading}
        />
    );
};
